import { computed } from "vue";
import { useSessionStorage } from "vue-composable";

const { storage: square_footage } = useSessionStorage('square_footage', 500);
const { storage: over_20_years_old } = useSessionStorage('over_20_years_old', false);
const { storage: has_pool } = useSessionStorage('square_footage', false);

const square_footage_base = computed(()=> 653 * square_footage.value / 1000)
const pool_multiplier = computed(() => has_pool.value ? 1.15 : 1);
const age_multiplier = computed(() => over_20_years_old.value ? 1.15 : 1);

const calculated_kwh = computed(()=> {
  const result = pool_multiplier.value * age_multiplier.value * square_footage_base.value;
  return Math.round(result);
})

const clear = () => {
  over_20_years_old.value = false;
  has_pool.value = false;
  square_footage.value = 500;
}

export default ()=> {
  return{
    square_footage,
    over_20_years_old,
    has_pool,
    calculated_kwh,
    clear,
  }
}
